import React from 'react'

const Sandbox = () => {
  return (
   
    <div className="sandbox-wrapper">

      <div className="sandbox-section phoneLogIn-section">

      </div>
    </div>
    



  )
}

export default Sandbox;